import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Card, Grid, Form } from 'tabler-react';
import DateInput from '../../Components/Playgrond/DateInput';
import Input from '../../Components/Playgrond/Input';


const propTypes = {};

const defaultProps = {};

class EditForm extends Component {
    state = {};

    onSubmitHandler = e => {
        console.log('form submited...');
        e.preventDefault();
    };

    onChangeHandler = e => {
        // console.log(e.target.name, ': ', e.target.value);
    };

    render() {
        return (
            <AuthenticatedTemplate title="Dados Cadastrais">
                <form method="POST" onSubmit={this.onSubmitHandler} autoComplete="off">
                    <Grid>
                        <Grid.Col>
                            <Card>
                                <Card.Header>Informações do Assinante</Card.Header>
                                <Card.Body>
                                    <Grid.Row>
                                        <Grid.Col md="8">
                                            <Form.Group label="Nome">
                                                <Input
                                                    name="name"
                                                    type="text"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>
                                        <Grid.Col md="4">
                                            <Form.Group label="Data de Nascimento">
                                                <DateInput
                                                    name="birthday"
                                                    type="tel"
                                                    placeholder="DD/MM/AAAA"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>
                                    </Grid.Row>
                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Header>Dados do Responsável Legal</Card.Header>
                                <Card.Body>
                                    <Grid.Row>
                                        <Grid.Col md="8">
                                            <Form.Group label="Nome">
                                                <Input
                                                    name="guardian_name"
                                                    type="text"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col col="4">
                                            <Form.Group label="Data de Nascimento">
                                                <DateInput
                                                    name="guardian_birthday"
                                                    type="tel"
                                                    placeholder="DD/MM/YYYY"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Col col="4">
                                            <Form.Group label="RG">
                                                <Input
                                                    name="guardian_document2"
                                                    type="tel"
                                                    numberOnly
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col col="4">
                                            <Form.Group label="Órgão Expedidor">
                                                <Input
                                                    name="guardian_document2_issuer"
                                                    type="text"
                                                    maxLength={10}
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col col="4">
                                            <Form.Group label="Data de Expedição">
                                                <DateInput
                                                    name="guardian_document2_shipping_date"
                                                    type="tel"
                                                    placeholder="DD/MM/YYYY"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>
                                    </Grid.Row>
                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Header>Endereço</Card.Header>
                                <Card.Body>
                                    <Grid.Row>
                                        <Grid.Col md="3">
                                            <Form.Group label="CEP">
                                                <Input
                                                    name="address_zipcode"
                                                    type="tel"
                                                    numberOnly
                                                    maxLength={8}
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col md="6">
                                            <Form.Group label="Endereço">
                                                <Input
                                                    name="address"
                                                    type="text"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col md="3">
                                            <Form.Group label="Número">
                                                <Input
                                                    name="address_number"
                                                    type="tel"
                                                    numberOnly
                                                    maxLength={5}
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col md="4">
                                            <Form.Group label="Complemento">
                                                <Input
                                                    name="address_complement"
                                                    type="text"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col md="3">
                                            <Form.Group label="Bairro">
                                                <Input
                                                    name="address_district"
                                                    type="text"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col md="3">
                                            <Form.Group label="Cidade">
                                                <Input
                                                    name="address_city"
                                                    type="text"
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>

                                        <Grid.Col md="2">
                                            <Form.Group label="UF">
                                                <Input
                                                    name="address_uf"
                                                    type="text"
                                                    maxLength={2}
                                                    pipe={v => v.toUpperCase()}
                                                    onChange={this.onChangeHandler}
                                                />
                                            </Form.Group>
                                        </Grid.Col>
                                    </Grid.Row>
                                </Card.Body>
                            </Card>

                        </Grid.Col>
                    </Grid>
                </form>
            </AuthenticatedTemplate>
        );
    }
}

EditForm.propTypes = propTypes;
EditForm.defaultProps = defaultProps;

export default EditForm;
